export enum SidebarMenuItemState {
    Loading = "Loading",
    Error = "Error",
    Loaded = "Loaded"
}